import { useState } from 'react';
import { vendorAssetUrl } from '@mypoz/shared';
import { Icon } from '@mypoz/ui';

import { legacyAssetOrigin } from '@/lib/legacy-api.js';

export interface ServiceImageProps {
  /** The vendor's `img` (MYP-116): a site path or a full URL. Unset when it sent none. */
  src?: string;
}

/**
 * A service's picture in a fixed square, so every service card lines up whatever the vendor sent:
 * most images are small icons, one is 590×1048, and `object-contain` keeps each whole and
 * undistorted.
 *
 * Decorative (`alt=""`): the service's name sits right beside it. When there is no image — 26 of
 * the 48 live services — or it fails to load — 10 of the 22 the vendor lists are missing from its
 * server — a neutral package icon takes the same square, instead of the broken-image glyph the old
 * site shows. The fix for those is the vendor re-uploading them; nothing here needs to change then.
 */
export function ServiceImage({ src }: ServiceImageProps) {
  const [failed, setFailed] = useState(false);
  const url = src && !failed ? vendorAssetUrl(src, legacyAssetOrigin) : undefined;

  return (
    <span className="flex size-14 shrink-0 items-center justify-center overflow-hidden rounded-md bg-surface-alt">
      {url ? (
        <img
          src={url}
          alt=""
          loading="lazy"
          onError={() => setFailed(true)}
          className="size-full object-contain"
        />
      ) : (
        <Icon name="inventory_2" size={26} className="text-muted-soft" />
      )}
    </span>
  );
}
